import { render, staticRenderFns } from "./SuspendSenderId.vue?vue&type=template&id=3355c386&"
import script from "./SuspendSenderId.vue?vue&type=script&lang=js&"
export * from "./SuspendSenderId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports